/** @format */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'starRatingNumber',
	standalone: false
})
export class StarRatingNumberPipe implements PipeTransform {
	transform(value: number): string {
		return (Math.round(10 * value) / 10).toFixed(1);
	}
}
